import './BreathingBox.css';
import { Link } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";
// Assuming these are correct paths for your app
import { getToken } from "../../helpers";
import { API } from "../../constant";
import { useAuthContext } from "../../context/AuthContext";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
// import repeatButton from"../../Media/Repeat Exercise.svg";
// import nextButton from "../../Media/Next.svg";
// import finshedCloud from "../../Media/Finished screen.svg"

// Soothing bell chime using Web Audio API — no audio file needed
// Each breath phase gets a slightly different note so the corner feels distinct
const CHIME_FREQS = [
    528,  // Inhale  — bright, uplifting
    440,  // Hold    — neutral, steady
    396,  // Exhale  — lower, releasing
    440,  // Hold    — neutral, steady
];

function playChime(stepIndex) {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        if (ctx.state === 'suspended') ctx.resume();

        const freq = CHIME_FREQS[stepIndex] ?? 440;
        const masterGain = ctx.createGain();
        masterGain.connect(ctx.destination);

        // Two oscillators (fundamental + bell harmonic) for a warm bell tone
        [1, 2.756].forEach((ratio, i) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(masterGain);

            osc.type = 'sine';
            osc.frequency.setValueAtTime(freq * ratio, ctx.currentTime);

            // Soft attack, slow natural decay
            gain.gain.setValueAtTime(0, ctx.currentTime);
            gain.gain.linearRampToValueAtTime(i === 0 ? 0.28 : 0.10, ctx.currentTime + 0.04);
            gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 1.8);

            osc.start(ctx.currentTime);
            osc.stop(ctx.currentTime + 1.8);
        });

        setTimeout(() => ctx.close(), 2200);
    } catch (e) {
        // AudioContext unavailable — fail silently
    }
}

function BreathingBox(items) {
  const { user } = useAuthContext();
  const [round, setRound] = useState(1);
  const [currRound, setcurrRound] = useState(1);
  const [count, setCount] = useState(0);
  const [step, setStep] = useState(-1); // Start at -1, so the dot is at initial position before start
  const [countdown, setCountdown] = useState("");
  const [afterFinish, setAfterFinish] = useState(false);
  const [dotRoundDuration, setDotRoundDuration] = useState(0);
  const intervalRef = useRef(null);


  const steps = 4;
  const totalRounds = 5; // Set the total rounds you want to practice
  const round_duration = 4; // Set the duration of a round (In seconds)
  const totalDuration = steps * totalRounds * round_duration;

  const startCounter = () => {
    // Reset state and start
    setCount(1); // Start count immediately at 1
    setStep(0); // Set step to 0 immediately to move the dot
    
    intervalRef.current = setInterval(() => {
      setCount(prevCount => {
        const newCount = prevCount + 1;
        
        if (newCount > totalDuration) {
          clearInterval(intervalRef.current);
          return prevCount; 
        }
        return newCount;
      });
    }, 1000); // 1 second delay
  };

  useEffect(() => {
    
    if (count > 0 && count <= totalDuration) {
      // Calculate the current step (0: In, 1: Hold, 2: Out, 3: Hold)
      const currentStep = (Math.floor((count - 1) / round_duration)) % 4; 
      const currentRound = Math.floor((count - 1) / (round_duration * 4)) + 1; 
      const countdn = (Math.floor((count - 1) % round_duration)) + 1;
      const rd = round_duration; // Using the full duration here for the countdown transition
      setcurrRound(currentRound)
      setDotRoundDuration(rd); // This is not strictly needed for the dot position but kept for your internal use
      
      setStep(currentStep);

      // Chime at the first tick of every new step (each corner of the box)
      if ((count - 1) % round_duration === 0) {
        playChime(currentStep);
      }

      if(currentStep=="0")
      setRound(<span className="fade-in-down">Inhale</span>);
      if(currentStep=="1")
        setRound(<span className="fade-in-down">Hold</span>);
      if(currentStep=="2")
        setRound(<span className="fade-in-down">Exhale</span>);
      if(currentStep=="3")
        setRound(<span className="fade-in-down">Hold</span>);
      setCountdown(countdn);

      // Handle finish logic
      if(totalDuration === count){
        setTimeout(function() {
          setCountdown("");
          setRound("");
          setCountdown(<span className='pulse'>Finished!</span>);
          setAfterFinish(true);
        }, 1000);
      }
      
    }
  }, [count, round_duration, totalDuration]);

  useEffect(() => {
    return () => {
      // Clean up the interval when the component unmounts
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  let userId;
  if (user !== undefined) {
    userId = user.id;
  }

  const finishButton = () => {
    // ... your existing finish button logic ...
    // fetch(`${API}/users/${userId}?populate=*`)
    //  .then((res) => {
    //    return res.json();
    //  })
    //  .then((data) => {
    //    let completed =[];
    //    data.completed_skill.map((item, index)=>{
    //        completed[index] = {id:item.id}
    //    })
    //    completed.push({id: items.SkillId});
    //    const userResponse = fetch(`${API}/users/${userId}`, {
    //        method: "PUT",
    //        headers: {
    //          "Content-Type": "application/json",
    //          Authorization: `Bearer ${getToken()}`,
    //        },
    //        body: JSON.stringify(
    //          { 
    //              completed_skill: completed
    //          }
    //        ),
    //      });
    //    if(userResponse){
    //      console.log("Data added successfully");
    //    }
    //  });
  };

  const handleRepeatExercise = () => {
    // Clear the interval if it exists
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    // Reset all state to initial values
    setCount(0);
    setStep(-1);
    setAfterFinish(false);
    setRound(1);
    setcurrRound(1);
    setCountdown("");
  };

  const finishedPrectice = <div className="buttons bounce-in">
    <div className="btn-icon btn-repeat" onClick={handleRepeatExercise}>
      {/* <img src={repeatButton} alt="Repeat Button"/> */}
    </div>
    <Link to="./../../Activities">
      <div className="btn-icon btn-next" onClick={finishButton}>
        {/* <img src={nextButton} alt="Next Button"/> */}
      </div>
    </Link>
  </div>

  const rounIndicators = <div className="round-indicator bounce-in">
    {[...Array(totalRounds).keys()].map((i)=>{
      return <div className={`indicator ${currRound===i + 1 ?'active':''}`}></div>
    })}
  </div>

  const breathBox = <div className="breath-box bounce-in">
    <div className="breath-box-inner">
      <div className={`count-div step-${step}`}>
        <div className={`breath-dot step-${step}`} id="movingDot"></div>
        <h2 className="breath-count">{count===0?<span className='pulse'>Let's Start!</span>:countdown}</h2> 	
      </div>
    </div>
  </div>

  const finishedBox = <div className="finshed-box fade-in-down">
    <div className="icon icon-cloud"></div>
    <h2>Finished!</h2>
    <h4>Great job.</h4>
  </div>

  return (
    <div className='box-breathing'>
      <div className="container">
        <Header type="primary" />
        <div className="content-wrap bg-gradient breathing-box-page">
        <div  className="breath-box-wrapper">

          {afterFinish?finishedBox:breathBox}
          {afterFinish?finishedPrectice:
          <div className="round fade-in-down">
            {count===0?
              <button className="button-right-arrow light hover-bounce" onClick={startCounter}>
                Start <span className="arrow-right"></span>
              </button>
            :round}
          </div>}
          {afterFinish?"":rounIndicators}
        </div>
        </div>
        <Footer />
      </div>
    </div>
    
    
  );
}

export default BreathingBox;